import * as React from 'react';
import { Flex, Box, flameTheme } from '@lightspeed/flame/Core';
import { Text } from '@lightspeed/flame/Text';
import { Switch } from '@lightspeed/flame/Switch';
import SocketClient from 'pages/views/devices/socketClient';
import { HUB_MESSAGES } from 'pages/views/devices/socketClient/types';
import { getOptions, setOptions } from 'pages/views/devices/utils/options';
import { OPTIONS } from './types';

type CopyType = {
  [key in OPTIONS]: {
    text: string;
    subtext?: string;
  };
};
interface OptionProps {
  option: OPTIONS;
}

interface SetOptionsI {
  option: OPTIONS;
  value: boolean;
}

const copy: CopyType = {
  [OPTIONS.IS_CUSTOMER_NAME_VISIBLE]: {
    text: 'Show customer first name (if available)',
  },
  [OPTIONS.IS_UNTAXED_ITEM_NOTE_VISIBLE]: {
    text: 'Show “No tax applied” on untaxed items',
  },
  [OPTIONS.IS_QRCODE_VISIBLE]: {
    text: "Show the Sale's QR Code",
  },
  [OPTIONS.IS_CONNECTION_STATUS_VISIBLE]: {
    text: 'Show connection status',
  },
  [OPTIONS.IS_LOGO_VISIBLE]: {
    text: 'Show logo',
  },
  [OPTIONS.IS_DEBUG_MODE]: {
    text: 'Log messages to browser console',
    subtext: 'Enable to help our support team solve issues.',
  },
};

const Option: React.FC<OptionProps> = ({ option }) => {
  const [currentOptions, setCurrentOptions] = React.useState(getOptions());
  const { colors } = flameTheme;
  const { text, subtext } = copy[option];

  const setOption = ({ option: currentOption, value }: SetOptionsI) => {
    const options = getOptions();
    options[currentOption] = value;
    setCurrentOptions(options);
    setOptions(options);
    SocketClient.send(HUB_MESSAGES.UPDATE_CONFIG, { config: { [currentOption]: value } });
  };

  return (
    <Flex justifyContent="space-between" alignItems="center">
      <Box>
        <Text fontSize="small" fontWeight="bold">
          {text}
        </Text>
        {subtext ? (
          <Text fontSize="small" fontWeight="bold" color={colors.textDimmed} mt={2}>
            {subtext}
          </Text>
        ) : null}
      </Box>
      <Switch
        data-test={`option-${option}`}
        onChange={e => setOption({ option, value: e.currentTarget.checked })}
        checked={currentOptions[option]}
      />
    </Flex>
  );
};

export { Option };
